import { DropDownView, FilterType } from '@gripp/shared-ui';
import { View } from 'react-native';
import { ProductFilter } from './productFilter';

type ProductFilterMenuProps = {
  onProductFilterOpen: () => void;
  onProductFilterClose: () => void;
  isOpened: boolean;
  anchorRef: React.RefObject<View>;
  type: FilterType;
};

export const ProductFilterMenu = ({
  onProductFilterClose,
  onProductFilterOpen,
  isOpened,
  anchorRef,
  type,
}: ProductFilterMenuProps) => {
  return (
    <DropDownView
      anchorRef={anchorRef}
      isVisible={isOpened}
      onDismiss={onProductFilterClose}
    >
      <ProductFilter onCloseSideBar={onProductFilterClose} type={type} />
    </DropDownView>
  );
};
